import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const orderId = searchParams.get('orderId') || '';
    const paymentKey = searchParams.get('paymentKey') || '';
    const amountStr = searchParams.get('amount') || '';
    const amount = Number(amountStr);

    if (!orderId || !paymentKey || !amountStr || Number.isNaN(amount)) {
      setErrorMsg('결제 파라미터가 올바르지 않습니다.');
      setLoading(false);
      return;
    }

    const fetchConfirmPayment = async () => {
      try {
        setLoading(true);
        setErrorMsg('');

        const savedForm = sessionStorage.getItem('reviewApplyPayload');
        if (!savedForm) {
          throw new Error('신청 정보가 유실되었습니다. 다시 시도해 주세요.');
        }

        const formData = JSON.parse(savedForm);

        await axios.post('/payment/confirm', {
          orderId,
          paymentKey,
          amount,
          ...formData, // 🔥 신청 정보 함께 전송
        });

        sessionStorage.removeItem('reviewApplyPayload');

        alert('결제가 정상적으로 완료되었습니다.');
        navigate('/ReviewPage');
      } catch (error) {
        console.error('결제 에러:', error);
        setErrorMsg(
          error?.response?.data?.errorMessage ||
            error?.response?.data?.message ||
            error.message ||
            '결제 확인 중 오류가 발생했습니다.'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchConfirmPayment();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-dvh">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-sky-500 mr-3"></div>
        <div className="text-sm text-slate-500">결제 확인 중...</div>
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div className="flex flex-col justify-center items-center h-dvh gap-3">
        <div className="text-red-500 font-bold">결제 확인 실패</div>
        <div className="text-gray-700 text-sm">{errorMsg}</div>
        <button
          className="px-4 py-2 rounded-xl bg-sky-500 text-white"
          onClick={() => navigate('/ReviewPage')}>
          목록으로
        </button>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-dvh">
      <div className="text-gray-700">결제 확인 완료</div>
    </div>
  );
}
